var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "changepswd" }, [
    _c("div", { staticClass: "clonePopUp" }, [
      _c("div", { staticClass: "pop-title" }, [
        _c("div", { staticClass: "pop-input" }, [
          _c("ul", { staticStyle: { "list-style": "none" } }, [
            _c("li", [
              _c("span", [_vm._v("旧密码：")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.oldpaswd,
                    expression: "oldpaswd",
                  },
                ],
                class: { borderactive: _vm.inconformity1 },
                attrs: { id: "ativeFocus", type: "password" },
                domProps: { value: _vm.oldpaswd },
                on: {
                  focus: function ($event) {
                    return _vm.focus($event, 1)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.oldpaswd = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.oldp,
                      expression: "oldp",
                    },
                  ],
                  style: { color: _vm.errorpawdgrade },
                },
                [_vm._v("\n              请输入旧密码\n            ")]
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", [_vm._v("新密码：")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newpaswd,
                    expression: "newpaswd",
                  },
                ],
                class: { borderactive: _vm.inconformity2 },
                attrs: { type: "password" },
                domProps: { value: _vm.newpaswd },
                on: {
                  blur: function ($event) {
                    return _vm.blur()
                  },
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.newpaswd = $event.target.value
                    },
                    function ($event) {
                      return _vm.changwd()
                    },
                  ],
                  focus: function ($event) {
                    return _vm.focus($event, 2)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pawdgrade1,
                      expression: "pawdgrade1",
                    },
                  ],
                  style: { color: _vm.errorpawdgrade1 },
                },
                [
                  _vm._v(
                    "\n              " + _vm._s(this.newHint) + "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pawdgrade,
                      expression: "pawdgrade",
                    },
                  ],
                },
                [
                  _vm._v("\n              密码安全程度："),
                  _c("b", { style: { color: _vm.activeColor } }, [
                    _vm._v(_vm._s(_vm.grade)),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", [_vm._v("确认密码：")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.againpaswd,
                    expression: "againpaswd",
                  },
                ],
                class: { borderactive: _vm.inconformity3 },
                attrs: { type: "password" },
                domProps: { value: _vm.againpaswd },
                on: {
                  focus: function ($event) {
                    return _vm.focus($event, 3)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.againpaswd = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.inconformity3,
                      expression: "inconformity3",
                    },
                  ],
                  style: { color: _vm.error },
                },
                [_vm._v("\n              两次输入的密码不一致\n            ")]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pop-btn" }, [
          _c(
            "span",
            {
              staticClass: "sav-btn",
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("确认")]
          ),
          _vm._v(" "),
          !_vm.openFrom
            ? _c(
                "span",
                {
                  staticClass: "cancel-btn",
                  on: {
                    click: () => {
                      this.$emit("closeActionDialog", false)
                    },
                  },
                },
                [_vm._v("取消")]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }